import ManagedReminders from "./ManagedReminders";
export default ManagedReminders;
